import { baseUrl, baseUrlName } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

export const getChargesRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/billing-api/charges/search`,
    searchParams: params,
  });

export const getChargesRouteV2 = (params) =>
  buildUrl({
    url: `${baseUrl}/billing-api/charges/searchv2`,
    searchParams: params,
  });

export const getChargesRoute2 = (params) =>
  buildUrl({
    url: `${baseUrl}/billing-api/charges`,
    searchParams: params,
  });

export const getChargesDetailsRoute = (...params) =>
  [`${baseUrl}`, "billing-api", ...params].join("/");

export const deleteAdjustmentRoute = (...params) =>
  [`${baseUrl}`, "billing-api", "adj?", ...params].join("/");

export const createUpdateAdjustmentRoute = (agreementId, adjustmentTypeId, ...params) =>
  [
    `${baseUrl}`,
    "billing-api",
    `adj?agreementId=${agreementId}&adjustmentTypeId=${adjustmentTypeId}`,
    ...params,
  ].join("/");

export const postChargesMassRoute = (date) =>
  [`${baseUrl}`, "billing-api", "charges", `mass?onDate=${encodeURIComponent(date)}`].join("/");

export const postChargeRoute = () => {
  switch (baseUrlName) {
    case "numericIds":
    case "default":
    default:
      return [`${baseUrl}`, "billing-api", "charges", "v2"].join("/");
  }
};

export const postChargesBulkRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/billing-api/charges/bulk`,
    searchParams: params,
  });
